import { render, staticRenderFns } from "./RestoreFunnelsByLocation.vue?vue&type=template&id=5a4ef710&"
import script from "./RestoreFunnelsByLocation.vue?vue&type=script&lang=ts&"
export * from "./RestoreFunnelsByLocation.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreFunnelsByLocation.vue?vue&type=style&index=0&id=5a4ef710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports